// extracted by css-extract-rspack-plugin
export default {"clickable":"zyet4V","spacer":"V5gZwd","otp":"bAJeV4","description":"n1W3x4","resend":"e5Kgyv","active":"Yce1mv"};